import { Button, Modal } from 'antd';
import { CreateReview, NotificationAlert, Table } from '../../../components';
import { columns } from './columns';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Paths } from '../../../routes';
import { getAllQuarters } from '../../../services/reviewsServices';
import { AllReviewsProps } from '../../../types';

const QuarterlyReviews = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [editID, setEditID] = useState<string | null>(null);
  const [data, setData] = useState<AllReviewsProps[]>([]);
  const myRef = useRef<any>();
  const [loading, setLoading] = useState(true);

  const fetchReviews = async () => {
    setLoading(true);
    const { data, error } = await getAllQuarters('hr');
    setLoading(false);
    if (error) return myRef.current?.call('error', error?.message);
    if (data) {
      setData(data);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  const handleClick = (data: AllReviewsProps) => {
    setEditID(data?.id);
    setOpen(true);
  };

  return (
    <div className="flex flex-col gap-y-[10px]">
      <div className="p-[10px] flex flex-col gap-y-[10px]">
        <div className="flex py-[10px]">
          <div>
            <div className="text-[20px] font-[500]">All Quarterly Reviews</div>
            <div className="opacity-45">
              View, edit, and manage existing quarterly review cycles
              effortlessly.
            </div>
          </div>

          <div className="ml-auto">
            <Button
              type="primary"
              onClick={() => navigate(Paths.CreateCycleFromAllQuarter)}
            >
              Create New Review Cycle
            </Button>
          </div>
        </div>
      </div>
      <Table
        columns={columns(handleClick)}
        data={data}
        errorFetchingData={false}
        loading={loading}
        rowKey="id"
      />
      <Modal
        title={
          <div className="text-[20px] font-[500]">
            Edit Quarterly Review Cycle
          </div>
        }
        centered
        open={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        width={1024}
        footer={<></>}
        destroyOnClose
      >
        <CreateReview
          editID={editID}
          setOpen={setOpen}
          fetchData={fetchReviews}
        />
      </Modal>
      <NotificationAlert ref={myRef} />
    </div>
  );
};

export default QuarterlyReviews;
